export function filterNullEntity<T>(entity: T): T {
  return Object.keys(entity).reduce((clearedEntity, key) => {
    if (entity[key] || entity[key] === 0 || entity[key] === false) {
      clearedEntity[key] = entity[key];
    }
    return clearedEntity;
  }, {} as T);
}
